import { formatAccessDeniedMessage } from '../../../utils/accessDeniedMessage';
import { DOCUMENT_REPORT_SCOPE_PERMISSIONS } from './documentReportScopeUtils';

export function getDocumentReportGenerateAccess({ hasEInvoicePermission, docReportLabels, adminEmail }) {
  const allowedTypes = DOCUMENT_REPORT_SCOPE_PERMISSIONS.filter(({ permission }) =>
    hasEInvoicePermission(permission),
  ).map(({ labelKey }) => docReportLabels[labelKey] ?? labelKey);

  const hasSalesPurchaseScope = allowedTypes.length > 0;

  if (!hasSalesPurchaseScope) {
    const template =
      docReportLabels.generate_no_sales_purchase_tooltip ??
      'You do not have permission to access sales or purchase documents. Please contact your organization admin ({email}) to update your permissions.';
    return {
      hasSalesPurchaseScope: false,
      tooltipMessage: formatAccessDeniedMessage(template, adminEmail),
    };
  }

  const scopeTemplate =
    docReportLabels.generate_scope_tooltip ??
    'This report will only include documents you have access to: {documentTypes}.';
  const tooltipMessage = scopeTemplate.replace('{documentTypes}', allowedTypes.join(', '));

  return {
    hasSalesPurchaseScope: true,
    tooltipMessage,
  };
}
